import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { APP_BASE_HREF } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppComponent } from './app.component';
import { routes } from './app.routes';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';

import { HomeModule } from './home/home.module';
import { UnderMaintenanceComponent } from './under-maintenance/under-maintenance.component';
import { SharedModule } from './shared/shared.module';
import { SpinnerComponent, SpinnerService } from './shared/spinner/index';
import { ScheduleInterviewModule } from './schedule-interview/schedule-interview.module';
import { CancelInterviewModule } from './cancel-interview/cancel-interview.module';
import { CSSMonitorService } from './shared/services/css-monitor.service';

import { ReferenceService } from './shared/services/reference.service';
import { PaperworkService } from './shared/services/paperwork.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader/';
import { environment } from 'src/environments/environment';
import { HttpRequestInterceptor } from './http-request-interceptor';

export function translateModuleFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, environment.APP_BASE + 'assets/i18n/', '.json');
}

@NgModule({ declarations: [
        AppComponent,
        SpinnerComponent,
        UnderMaintenanceComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        RouterModule.forRoot(routes, {
            initialNavigation: "disabled"
        }),
        HomeModule,
        ScheduleInterviewModule,
        CancelInterviewModule,
        SharedModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: translateModuleFactory,
                deps: [HttpClient]
            }
        })], providers: [
        TranslateService,
        {
            provide: APP_BASE_HREF,
            useValue: environment.APP_BASE
        },
        SpinnerService,
        ReferenceService,
        PaperworkService,
        CSSMonitorService,
        provideAppInitializer(() => {
        const initializerFn = ((referenceService: ReferenceService) => () => {
                return referenceService.initPullData();
            // })(inject(ReferenceService), inject(HttpClient));
             }) (inject(ReferenceService));
            return initializerFn();
      }),
        { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi())
    ] })

export class AppModule { }
